import { toastController } from "@ionic/vue";

export const toISOStringWithTimezone = (date: any) => {
  const tzOffset = -date.getTimezoneOffset();
  const diff = tzOffset >= 0 ? "+" : "-";
  const pad = (n: any) => `${Math.floor(Math.abs(n))}`.padStart(2, "0");
  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    "T" +
    pad(date.getHours()) +
    ":" +
    pad(date.getMinutes()) +
    ":" +
    pad(date.getSeconds()) +
    diff +
    pad(tzOffset / 60) +
    ":" +
    pad(tzOffset % 60)
  );
};

export const presentToastWithOptions = async (_message: string, color = "primary", position: 'top' | 'bottom' | 'middle' = "top") => {
      
  const toast = await toastController.create({
    message: _message,
    // showCloseButton: true,
    position: position,
    color: color,
    duration: 3000,
  })
  return await toast.present()
}

export const toDataURL = (url: string, callback: any) => {
  const xhr = new XMLHttpRequest();

  xhr.onload = function() {
    const reader = new FileReader();
    reader.onloadend = function() {
      callback(reader.result);
    }
    reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', url);
  xhr.setRequestHeader("Acess-Control-Allow-Origin", "*")
  xhr.responseType = 'blob';
  xhr.send();
}

export const checkNickNameString = (strings: string) => {
  const regexr = /^@+[a-z0-9_]*$/;
  const result = regexr.test(strings);
  return result;
};

export const convertImageToBase64 = (imgUrl: any, callback: any) => {
  const image = new Image();
  image.crossOrigin='anonymous';
  image.onload = () => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.height = image.naturalHeight;
    canvas.width = image.naturalWidth;
    ctx?.drawImage(image, 0, 0);
    const dataUrl = canvas.toDataURL();
    callback && callback(dataUrl)
  }
  image.src = imgUrl;
}